import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import { api } from './api';

// "Deal conversations" card for the borrower / realtor portal homes. Renders
// nothing until the caller has at least one deal.
export default function MyDealConversations() {
  const [deals, setDeals] = useState([]);
  useEffect(() => {
    let live = true;
    api.get('/deals/mine/external')
      .then(({ data }) => { if (live && Array.isArray(data)) setDeals(data); })
      .catch(() => {});
    return () => { live = false; };
  }, []);
  if (!deals.length) return null;
  return (
    <div className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm mb-6" data-testid="my-deal-conversations">
      <div className="flex items-center gap-2 mb-3">
        <MessageSquare size={14} className="text-brand-navy" />
        <h2 className="font-serif text-lg font-bold text-brand-navy">Deal conversations</h2>
      </div>
      <ul className="divide-y divide-slate-100">
        {deals.map((d) => (
          <li key={d.deal_id}>
            <Link to={`/deal/${d.deal_id}`} className="flex items-center justify-between py-2 text-sm text-slate-700 hover:text-brand-navy">
              <span>{d.address || 'Deal'}</span>
              <span className="text-xs uppercase tracking-wider text-slate-400">{String(d.role || '').replace(/_/g, ' ')}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
